import { useEffect, useState } from "react";
import { Cpu } from "lucide-react";
import { getToken } from "@/lib/api";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const card = { background: "#1A1A1A", border: "1px solid #333333", borderRadius: 14 };
export const DIALOG_FIT = { maxHeight: "calc(90vh - var(--lso-banner-h, 0px))", top: "calc(50% - var(--lso-banner-h, 0px) / 2)" };
export const inp = { width: "100%", background: "#0A0A0A", border: "1px solid #333", borderRadius: 8, padding: "10px 12px", color: "#fff", fontSize: 14, outline: "none" };
export const lab = { display: "block", color: "#A0A0A0", fontSize: 10, fontWeight: 800, letterSpacing: 1.2, marginBottom: 4 };
export const greenBtn = { padding: "10px 16px", borderRadius: 10, background: "#4CCC06", color: "#000", fontWeight: 800, fontSize: 13 };
export const ghostBtn = { padding: "8px 14px", borderRadius: 10, border: "1px solid #333", color: "#fff", fontWeight: 700, fontSize: 12 };
export const OUTCOMES = [["clean", "Clean result", "#4CCC06"], ["good", "Good, minor touch-up", "#9BE15D"], ["needs_more", "Needs another pass", "#F5B700"], ["damaged", "Damaged the surface", "#FF6B6B"]];
export const outcomeOf = (k) => OUTCOMES.find((o) => o[0] === k) || OUTCOMES[1];

export const MachineArt = ({ item, h = 120 }) => {
  const [failed, setFailed] = useState(false);
  const src = item.image_path ? `${BASE}/api/laser/catalog/${item.catalog_id || item.id}/image?v=${item.image_ver || ""}` : item.static_image;
  if (src && !failed) {
    return <img data-testid={`machine-image-${item.catalog_id || item.id}`} src={src} alt={item.name} onError={() => setFailed(true)}
      style={{ width: "100%", height: h, objectFit: "contain", borderRadius: 10, background: "#0A0A0A" }} />;
  }
  return (
    <div data-testid={`machine-placeholder-${item.catalog_id || item.id}`} style={{ height: h, borderRadius: 10, background: "repeating-linear-gradient(135deg,#101010 0 10px,#141414 10px 20px)", border: "1px dashed #3a3a3a", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 6 }}>
      <Cpu size={28} color="#4CCC06" />
      <span style={{ color: "#4CCC06", fontSize: 18, fontWeight: 900 }}>{item.watts}W</span>
      <span style={{ color: "#707070", fontSize: 9, fontWeight: 700, letterSpacing: 1.5 }}>PHOTO COMING SOON</span>
    </div>
  );
};

export const AuthImg = ({ id, alt, testId, lazyVideo = false }) => {
  const [src, setSrc] = useState(null);
  const [video, setVideo] = useState(false);
  const [go, setGo] = useState(!lazyVideo);
  useEffect(() => {
    if (!go) return undefined;
    let url;
    fetch(`${BASE}/api/laser/photos/${id}`, { headers: { Authorization: `Bearer ${getToken()}` } })
      .then((r) => (r.ok ? r.blob() : null)).then((b) => { if (b) { url = URL.createObjectURL(b); setVideo(b.type.startsWith("video/")); setSrc(url); } }).catch(() => {});
    return () => url && URL.revokeObjectURL(url);
  }, [id, go]);
  const st = { width: "100%", height: 110, objectFit: "cover", borderRadius: 8 };
  if (!go) return <button data-testid={`${testId}-play`} onClick={() => setGo(true)} style={{ ...st, background: "#0A0A0A", border: "1px solid #2a2a2a", color: "#4CCC06", fontSize: 12, fontWeight: 800 }}>▶ Play {alt.toLowerCase()} video</button>;
  if (!src) return <div style={{ height: 110, borderRadius: 8, background: "#0A0A0A", border: "1px solid #2a2a2a" }} />;
  return video ? <video data-testid={testId} src={src} controls playsInline autoPlay={lazyVideo} style={st} /> : <img data-testid={testId} src={src} alt={alt} style={st} />;
};

export async function uploadLaser(path, file) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await fetch(`${BASE}/api/laser/${path}`, { method: "POST", headers: { Authorization: `Bearer ${getToken()}` }, body: fd });
  const j = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof j.detail === "string" ? j.detail : "Upload failed");
  return j;
}
